import { Input } from "@chakra-ui/input";
import { Box, Flex, Text } from "@chakra-ui/react";
import { Col, Modal, Row } from "antd";
import { CloseModalButton } from "components/Button/CloseModalButton";
import SelectAreaComum from "components/Input/SelectAreaComum";
import SelectTipoLocalEquipamento from "components/Input/SelectTipoLocalEquipamento";
import { FiltroEquipamentos } from "core/features/equipamento/typings/index";
import { TipoLocalEquipamentoEnum } from "features/equipamento/typings";
import { useEffect, useState } from "react";
import FooterModal from "ui/components/Button/FooterModal";
import Toolbar from "ui/components/Toolbar";

interface ModalFiltrosProps {
  isOpen: boolean;
  onClose: () => any;
  filtro: FiltroEquipamentos;
  onChangeFiltro: (filtro: Partial<FiltroEquipamentos>) => any;
  onReset: (filtro?: Partial<FiltroEquipamentos>) => any;
}

function ModalFiltros({
  isOpen,
  onClose,
  filtro,
  onChangeFiltro,
  onReset,
}: ModalFiltrosProps) {
  const [localFiltro, setLocalFiltro] = useState<FiltroEquipamentos>(filtro);

  useEffect(() => {
    setLocalFiltro(filtro);
  }, [filtro]);

  return (
    <Modal
      visible={isOpen}
      onCancel={onClose}
      className="antd-custom-header"
      title={
        <Toolbar title="Filtros avançados" onClose={onClose} border="0px" />
      }
      closable={false}
      width="900px"
      centered
      footer={
        <Flex
          justifyContent="end"
          align="center"
          gap="8px"
          alignContent="center"
          alignItems="center"
        >
          <CloseModalButton
            closeModalLabel="Fechar"
            close={onClose}
            mt="32px"
          />
          <FooterModal
            isDisabled={false}
            onSubmit={() => {
              onChangeFiltro(localFiltro);
              onClose();
            }}
            onClose={() => {
              onReset();
              onClose();
            }}
            showRegisterAnother={false}
            primaryButtonText="Filtrar"
            buttonCancelarText="Limpar filtros"
            isLoadingSave={false}
            showBorderTop={false}
          />
        </Flex>
      }
    >
      <Box>
        <Text fontWeight="bold" mb="10px">
          Local
        </Text>

        <Box as={Row} gutter={16}>
          <Box as={Col} mb={4} md={12}>
            <Text mb="2px" fontSize="13px">
              Tipo do local
            </Text>
            <SelectTipoLocalEquipamento
              value={localFiltro.tipoLocalEquipamento}
              onChange={(v) =>
                setLocalFiltro((s) => ({
                  ...s,
                  tipoLocalEquipamento: v,
                  local: undefined,
                  areaComumId: undefined,
                }))
              }
            />
          </Box>
          {localFiltro.tipoLocalEquipamento ===
          TipoLocalEquipamentoEnum.AreaComum ? (
            <Box as={Col} mb={4} md={12}>
              <Text mb="2px" fontSize="13px">
                Área Comum
              </Text>
              <SelectAreaComum
                value={localFiltro.areaComumId}
                onChange={(v) =>
                  setLocalFiltro((s) => ({ ...s, areaComumId: v }))
                }
              />
            </Box>
          ) : null}
          {localFiltro.tipoLocalEquipamento ===
          TipoLocalEquipamentoEnum.Outros ? (
            <Box as={Col} mb={4} md={12}>
              <Text mb="2px" fontSize="13px">
                Local
              </Text>
              <Input
                value={localFiltro.local}
                onChange={(v) =>
                  setLocalFiltro((s) => ({ ...s, local: v.target.value }))
                }
              />
            </Box>
          ) : null}
        </Box>
      </Box>
    </Modal>
  );
}

export default ModalFiltros;
